import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants";

export const searchClose = () => {
	OcmMessenger.publish(messengerPublicationTypes.CLOSE_SEARCH);
};
